import clsx from "clsx";
import React, { useRef } from "react";
import { imageGenerationCategories } from "data/image-categories";
import { ScrollNavigation } from "./ScrollNavigation";

type ImageCategorieProps = {
  selectedImageStyleIndex: number;
  setSelectImageStyleIndex: (index: number) => void;
};

export const ImageCategories: React.FC<ImageCategorieProps> = ({
  selectedImageStyleIndex,
  setSelectImageStyleIndex,
}) => {
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  const handleTabClick = (index: number) => {
    setSelectImageStyleIndex(index);
    const container = scrollContainerRef.current;
    if (container) {
      const tabElement = container.children[index] as HTMLElement;
      if (tabElement) {
        tabElement.scrollIntoView({
          behavior: "smooth",
          inline: "center",
          block: "nearest", // 明确指定垂直方向为“最近”，避免向上滚动
        });
      }
    }
  };

  // Calculate scroll distance dynamically (you can adjust this logic)
  const cardWidth = 112; // Width of each card
  const gap = 2; // Gap between cards (gap-8 = 2rem = 32px assuming 1rem = 16px)
  const scrollDistance = cardWidth + gap;

  return (
    <ScrollNavigation
      scrollContainerRef={scrollContainerRef}
      scrollDistance={scrollDistance}
         className="flex overflow-x-auto whitespace-nowrap scroll-smooth scrollbar-hide items-center h-[138px] gap-2"
      // className="gap-8 pl-3 pr-1 py-[10px]"
    >
      {imageGenerationCategories.map((categorie, index) => (
        <div
          key={categorie.name}
          onClick={() => handleTabClick(index)}
          className={clsx(
            "flex-shrink-0 w-28 bg-white p-2 rounded-lg flex flex-col items-center justify-center border border-solid cursor-pointer transition-[colors,padding] duration-300 ease-in-out",
            {
              "border-[#4338CA] shadow-[0px_2px_6px_0px_rgba(0,0,0,0.15)] py-[14px]":
                index === selectedImageStyleIndex,
              "border-[#94A3B8]": index !== selectedImageStyleIndex,
            }
          )}
        >
          <div className="w-[96px] h-[64px] bg-[#D9D9D9] rounded-[4px] mb-2 flex flex-row items-center justify-center">
            {categorie.image && (
              <img
                src={categorie.image}
                alt={categorie.style}
                className="max-w-full max-h-full rounded-[4px]"
              />
            )}
          </div>
          <span
            className={clsx("block text-[14px]  text-center ", {
              "font-semibold text-[#3730A3]": index === selectedImageStyleIndex,
              "font-medium text-[#171717]": index !== selectedImageStyleIndex,
            })}
          >
            {categorie.style}
          </span>
          <span className="block text-[12px] text-[#737373] text-center">
            {categorie.prefectForShort}
          </span>
        </div>
      ))}
    </ScrollNavigation>
  );

  // return (
  //   <div className="w-full max-w-[calc(100vw-30px)] mx-auto py-2">
  //     <div
  //       ref={scrollContainerRef}
  //       className="flex overflow-x-auto whitespace-nowrap scroll-smooth scrollbar-hide items-center h-[138px] gap-2"
  //       // style={{
  //       //   WebkitOverflowScrolling: "touch", // 改善iOS滚动体验
  //       //   overflow: "-moz-scrollbars-none", // Firefox隐藏滚动条
  //       //   msOverflowStyle: "none", // IE/Edge隐藏滚动条
  //       // }}
  //     >
  //       {imageGenerationCategories.map((categorie, index) => (
  //         <div
  //           key={categorie.name}
  //           onClick={() => handleTabClick(index)}
  //           className={clsx(
  //             "flex-shrink-0 w-28 bg-white p-2 rounded-lg flex flex-col items-center justify-center border border-solid cursor-pointer transition-[colors,padding] duration-300 ease-in-out",
  //             {
  //               "border-[#4338CA] shadow-[0px_2px_6px_0px_rgba(0,0,0,0.15)] py-[14px]":
  //                 index === selectedImageStyleIndex,
  //               "border-[#94A3B8]": index !== selectedImageStyleIndex,
  //             }
  //           )}
  //         >
  //           <div className="w-[96px] h-[64px] bg-[#D9D9D9] rounded-[4px] mb-2 flex flex-row items-center justify-center">
  //             {categorie.image && (
  //               <img
  //                 src={categorie.image}
  //                 alt={categorie.style}
  //                 className="max-w-full max-h-full rounded-[4px]"
  //               />
  //             )}
  //           </div>
  //           <span
  //             className={clsx("block text-[14px]  text-center ", {
  //               "font-semibold text-[#3730A3]":
  //                 index === selectedImageStyleIndex,
  //               "font-medium text-[#171717]": index !== selectedImageStyleIndex,
  //             })}
  //           >
  //             {categorie.style}
  //           </span>
  //           <span className="block text-[12px] text-[#737373] text-center">
  //             {categorie.prefectForShort}
  //           </span>
  //         </div>
  //       ))}
  //     </div>
  //   </div>
  // );
};
